import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const BMWFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="BMW"
      slug="/lenders/mis-sold-bmw-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default BMWFinancePage
